function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay');
var WaitingTemplate = require('./waiting.template');
var Waiting = /*#__PURE__*/function () {
  function Waiting(app, mod) {
    _classCallCheck(this, Waiting);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true);
    this.claimTimeoutMs = 120000;
    this.claimTimeoutId = null;
    this.claimCountdownIntervalId = null;
    this.dev_mode = 0;
    this.devUiSuccessTimerId = null;
  }
  return _createClass(Waiting, [{
    key: "render",
    value: function render() {
      var _this = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.clearMonitoring();
      this.mod.attachStyleSheets();
      if (data.timeout) {
        this.overlay.show(WaitingTemplate(this.app, this.mod, {
          timeout: true
        }), function () {
          _this.clearMonitoring();
        });
        var closeBtn = document.querySelector('.waiting .saito-button-secondary');
        if (closeBtn) {
          closeBtn.onclick = function () {
            _this.close();
          };
        }
        return;
      }
      this.overlay.show(WaitingTemplate(this.app, this.mod), function () {
        _this.clearDevUiSuccessTimer();
        _this.clearMonitoring();
      });
      this.startMonitoring();
      if (this.dev_mode) {
        this.startDevUiSuccessTimer();
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.clearMonitoring();
      this.overlay.close();
    }
  }, {
    key: "startMonitoring",
    value: function startMonitoring() {
      var _this2 = this;
      this.clearMonitoring();
      this.claimTimeoutId = setTimeout(function () {
        var root = document.querySelector('.waiting');
        if (root && !root.classList.contains('timeout')) {
          _this2.render({
            timeout: true
          });
        }
      }, this.claimTimeoutMs);
      this.startBlockCountdown();
    }
  }, {
    key: "clearMonitoring",
    value: function clearMonitoring() {
      if (this.claimTimeoutId) {
        clearTimeout(this.claimTimeoutId);
        this.claimTimeoutId = null;
      }
      this.stopBlockCountdown();
      this.clearDevUiSuccessTimer();
    }
  }, {
    key: "clearDevUiSuccessTimer",
    value: function clearDevUiSuccessTimer() {
      if (this.devUiSuccessTimerId) {
        clearTimeout(this.devUiSuccessTimerId);
        this.devUiSuccessTimerId = null;
      }
    }
  }, {
    key: "startDevUiSuccessTimer",
    value: function startDevUiSuccessTimer() {
      var _this3 = this;
      this.clearDevUiSuccessTimer();
      this.devUiSuccessTimerId = setTimeout(function () {
        _this3.devUiSuccessTimerId = null;
        var root = document.querySelector('.waiting');
        if (!root || root.classList.contains('timeout')) {
          return;
        }
        _this3.close();
        _this3.mod.success_overlay.render({
          amountLabel: "".concat(_this3.app.wallet.convertNolanToSaito(_this3.mod.amount), " SAITO")
        });
      }, 10000);
    }
  }, {
    key: "startBlockCountdown",
    value: function startBlockCountdown() {
      var _this$app, _this$app2;
      this.stopBlockCountdown();
      var heartbeatMs = Number((_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.options) === null || _this$app === void 0 || (_this$app = _this$app.consensus) === null || _this$app === void 0 ? void 0 : _this$app.heartbeat_interval);
      if (!Number.isFinite(heartbeatMs) || heartbeatMs <= 0) {
        heartbeatMs = 30000;
      } else if (heartbeatMs < 1000) {
        heartbeatMs = Math.round(heartbeatMs * 1000);
      }
      var blockWindowSeconds = Math.max(1, Math.round(2 * heartbeatMs / 1000));
      var lastTs = Number(((_this$app2 = this.app) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.options) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.blockchain) === null || _this$app2 === void 0 ? void 0 : _this$app2.last_timestamp) || 0);
      var seconds = blockWindowSeconds;
      if (Number.isFinite(lastTs) && lastTs > 0) {
        var elapsedSec = Math.max(0, Math.floor((Date.now() - lastTs) / 1000));
        var intoWindow = elapsedSec % blockWindowSeconds;
        if (!(elapsedSec > 0 && intoWindow === 0)) {
          seconds = blockWindowSeconds - intoWindow;
          if (seconds <= 0) {
            seconds = blockWindowSeconds;
          }
        }
      }
      var renderSeconds = function renderSeconds() {
        var el = document.querySelector('.waiting .countdown');
        if (el) {
          el.textContent = String(seconds);
        }
      };
      renderSeconds();
      this.claimCountdownIntervalId = setInterval(function () {
        seconds -= 1;
        if (seconds <= 0) {
          seconds = blockWindowSeconds;
        }
        renderSeconds();
      }, 1000);
    }
  }, {
    key: "stopBlockCountdown",
    value: function stopBlockCountdown() {
      if (this.claimCountdownIntervalId) {
        clearInterval(this.claimCountdownIntervalId);
        this.claimCountdownIntervalId = null;
      }
    }
  }]);
}();
module.exports = Waiting;